export default "__VITE_ASSET__D_xEupk8__"